import React, { useEffect, useState } from 'react';
import * as _ from 'lodash.debounce';
import storage from 'helpers/storage';
import MessageSound from '../../assets/sounds/waterdrop.mp3';
import IncomingChatSound from '../../assets/sounds/default-incoming-chat-sound.mp3';
import { useSelector } from 'react-redux';
import {
  getEnableNotificationSound,
  getIncomingChatList,
  getMessageRecived
} from '../../features/messagingChats/messagingChats';

window.inter = null;
const checkEnable = key => {
  return JSON.parse(storage.getItem(key));
};

const NotificationComp = () => {
  // const [msgSound, setMsgSound] = useState(new Audio(sound));
  // const [incommingSound, setIncommingSound] = useState(new Audio(url));
  const [msgSound, setMsgSound] = useState(null);
  const [incommingSound, setIncommingSound] = useState(null);
  let messageRecived = useSelector(getMessageRecived);
  let enableNotificationSound = useSelector(getEnableNotificationSound);
  const incomingChatList = useSelector(getIncomingChatList);

  useEffect(() => {
    console.log(
      document.getElementById('msg_sound_audio'),
      document.getElementById('incoming_sound_audio')
    );
    setMsgSound(document.getElementById('msg_sound_audio'));
    setIncommingSound(document.getElementById('incoming_sound_audio'));
  }, []);

  // On Message Recive
  useEffect(() => {
    console.log('msg recived', messageRecived);
    if (messageRecived) {
      playMsgSound();
    }
  }, [messageRecived]);

  //  On Sound Enable or Silent Mode
  useEffect(() => {
    if (incomingChatList.length) {
      clearSound();
      playIncommingSound();
    }
  }, [enableNotificationSound]);

  // on Incomming Chat Recive
  useEffect(() => {
    console.log(incomingChatList);
    if (incomingChatList.length) playIncommingSound();
    else clearSound();
  }, [incomingChatList]);

  const playMsgSound = () => {
    const enable = checkEnable('enableSound');
    if (enable && msgSound.paused) {
      console.log('play');
      msgSound.play();
      _(() => {
        msgSound.pause();
        msgSound.currentTime = 0;
      }, 1500);
    }
  };

  const clearSound = () => {
    clearInterval(window.inter);
    window.inter = null;
    if (incommingSound) incommingSound.pause();
  };

  const playIncommingSound = () => {
    if (incommingSound.paused && !window.inter) {
      if (enableNotificationSound) {
        incommingSound.play();
      } else {
        incommingSound.pause();
        incommingSound.currentTime = 0;
      }
      window.inter = setInterval(() => {
        if (enableNotificationSound) {
          incommingSound.play();
        } else {
          incommingSound.pause();
          incommingSound.currentTime = 0;
        }
      }, 3000);
    }
  };
  return (
    <>
      <audio id="msg_sound_audio" src={MessageSound}></audio>
      <audio id="incoming_sound_audio" src={IncomingChatSound}></audio>
    </>
  );
};

export default NotificationComp;
